export default __webpack_public_path__ + "static/media/banner-1-1.f1824513.png";